import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Modal from '@material-ui/core/Modal';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import Divider from '@material-ui/core/Divider';
import { Document, Page, pdfjs } from 'react-pdf';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import GroupIdentityApprovalConfirm from './GroupIdentityApprovalConfirm';
import {
  getGroupIdentities,
  editIdentityGroupStatus
} from '../../actions/Identity';
import { sendLogin } from '../../auth/Auth';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${
  pdfjs.version
}/pdf.worker.js`;

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  document: {
    width: '90%',
    margin: '5px'
  },
  itemDiv: {
    margin: '20px auto'
  },
  previewCard: {
    minHeight: 400
  },
  pdfReader: {
    overflow: 'auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getGroupIdentities, editIdentityGroupStatus },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openApprovalProgress', 'updateOpenApprovalProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isApprovalSuccess', 'updateIsApprovalSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('document', 'setDocument', ''),
  withState('identityType', 'setIdentityType', 0),
  withState('approvalResult', 'setApprovalResult', 'CONFIRMED'),
  withState('approvalResultStr', 'setApprovalResultStr', '審査OK'),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('ngReason', 'setNgReason', ''),
  withState('status', 'setStatus', 0),
  withState('adminMemo', 'setAdminMemo', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.setAdminMemo(this.props.detail.adminMemo);
      this.props.setNgReason(this.props.detail.ngReason);
      if (
        this.props.detail.status !== null &&
        this.props.detail.status === 'CONFIRMED'
      ) {
        this.props.setApprovalResult('CONFIRMED');
        this.props.setApprovalResultStr('審査OK');
      } else if (
        this.props.detail.status !== null &&
        this.props.detail.status === 'RESERVED'
      ) {
        this.props.setApprovalResult('RESERVED');
        this.props.setApprovalResultStr('確認中（保留中）');
      } else if (
        this.props.detail.status !== null &&
        this.props.detail.status === 'REJECTION'
      ) {
        this.props.setApprovalResult('REJECTION');
        this.props.setApprovalResultStr('再提出依頼');
      } else if (
        this.props.detail.status !== null &&
        this.props.detail.status === 'NG'
      ) {
        this.props.setApprovalResult('NG');
        this.props.setApprovalResultStr('審査NG');
      }
      if (this.props.detail.bankAccountHolder) {
        this.props.setBankAccountHolder(this.props.detail.bankAccountHolder);
      }
      if (this.props.detail.bankAccountHolder) {
        this.props.setBankAccountHolder(this.props.detail.bankAccountHolder);
      }
      console.log(this.props.detail);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    detail,
    updateOpenApprovalModal,
    openApprovalConfirmModal,
    updateOpenApprovalConfirmModal,
    searchKey,
    openApprovalProgress,
    updateOpenApprovalProgress,
    loading,
    updateLoading,
    isApprovalSuccess,
    updateIsApprovalSuccess,
    resultMessage,
    setResultMessage,
    approvalResult,
    setApprovalResult,
    approvalResultStr,
    setApprovalResultStr,
    ngReason,
    setNgReason,
    adminMemo,
    setAdminMemo,
    bankAccountHolder,
    setBankAccountHolder
  }) => {
    const editConfirm = {
      approvalResultStr,
      ngReason,
      adminMemo,
      bankAccountHolder
    };
    const editParam = {
      approvalResult,
      ngReason,
      adminMemo,
      bankAccountHolder
    };

    const convertApprovalResultStr = mode => {
      if (mode === 'CONFIRMED') {
        setApprovalResultStr('審査OK');
      } else if (mode === 'RESERVED') {
        setApprovalResultStr('確認中（保留中）');
      } else if (mode === 'REJECTION') {
        setApprovalResultStr('再提出依頼');
      } else if (mode === 'NG') {
        setApprovalResultStr('審査NG');
      }
    };

    const cancelAction = () => updateOpenApprovalModal(false);
    const confirmAction = () => {
      updateOpenApprovalConfirmModal(true);
    };
    const backAction = () => updateOpenApprovalConfirmModal(false);
    const editAction = async () => {
      updateLoading(true);
      updateOpenApprovalProgress(true);
      const editedStatus = await actions
        .editIdentityGroupStatus(detail.identityId, editParam)
        .then(data => checkSession(data));
      if (editedStatus.type === 'EDIT_IDENTITY_GROUP_STATUS_SUCCESS') {
        updateIsApprovalSuccess(true);
        await actions
          .getGroupIdentities(searchKey)
          .then(data => checkSession(data));
        // alert('更新が完了しました。');
        // updateOpenApprovalConfirmModal(false);
        // updateOpenApprovalModal(false);
        setResultMessage('更新が完了しました。');
        updateLoading(false);
      } else {
        // alert('更新に失敗しました。');
        updateIsApprovalSuccess(false);
        setResultMessage('更新に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isApprovalSuccess) {
        updateOpenApprovalConfirmModal(false);
        updateOpenApprovalModal(false);
        updateOpenApprovalProgress(false);
      } else {
        updateOpenApprovalProgress(false);
      }
    };

    const isConfirm = detail.status !== null && detail.status === 'CONFIRMED';
    const registeredCopies =
      detail.identityImages && detail.identityImages.length > 0
        ? detail.identityImages &&
          detail.identityImages
            .filter(item => item.registeredCopy)
            .map(item => item.registeredCopy)
        : [];
    const sealCertificates =
      detail.identityImages && detail.identityImages.length > 0
        ? detail.identityImages &&
          detail.identityImages
            .filter(item => item.sealCertificate)
            .map(item => item.sealCertificate)
        : [];
    const others =
      detail.identityImages && detail.identityImages.length > 0
        ? detail.identityImages &&
          detail.identityImages.filter(item => item.other)
        : [];

    console.log('IMAGES: ', detail, registeredCopies, sealCertificates, others);

    return (
      <div className={classes.root}>
        <Typography variant="h6">本人確認書類審査</Typography>
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            ①【必須】登記簿謄本
          </Typography>
          {registeredCopies.map(item => (
            <Card className={classes.document}>
              <CardActionArea>
                {item.endsWith('.pdf') ? (
                  // eslint-disable-next-line jsx-a11y/alt-text
                  <Document file={item} onLoadError={console.error}>
                    <Page
                      renderMode="svg"
                      className={classes.pdfReader}
                      pageNumber={1}
                      scale={1}
                      onLoadError={error => console.error(error.message)}
                    />
                  </Document>
                ) : (
                  <CardMedia component="img" image={item} />
                )}
              </CardActionArea>
            </Card>
          ))}
          {registeredCopies.length === 0 && (
            <Typography>アップロードなし</Typography>
          )}
        </div>
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            ②【必須】印鑑証明
          </Typography>
          {sealCertificates.map(item => (
            <Card className={classes.document}>
              <CardActionArea>
                {item.endsWith('.pdf') ? (
                  // eslint-disable-next-line jsx-a11y/alt-text
                  // <embed
                  //   className={classes.previewCard}
                  //   src={item}
                  //   type="application/pdf"
                  //   width="100%"
                  //   height="100%"
                  // />
                  <Document file={item} onLoadError={console.error}>
                    <Page
                      renderMode="svg"
                      className={classes.pdfReader}
                      pageNumber={1}
                      scale={1}
                      onLoadError={error => console.error(error.message)}
                    />
                  </Document>
                ) : (
                  <CardMedia component="img" image={item} />
                )}
              </CardActionArea>
            </Card>
          ))}
          {sealCertificates.length === 0 && (
            <Typography>アップロードなし</Typography>
          )}
        </div>
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            振込先銀行通帳の1ページ目
          </Typography>
          {detail.bankImage !== null && (
            <Card className={classes.document}>
              <CardActionArea>
                <CardMedia component="img" image={detail.bankImage} />
              </CardActionArea>
            </Card>
          )}
          {detail.bankImage === null && (
            <Typography>アップロードなし</Typography>
          )}
        </div>
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            その他資料の添付
          </Typography>
          {others.map(item => (
            <>
              <Typography>{item.note}</Typography>
              <Card className={classes.document}>
                <CardActionArea>
                  {item.other.endsWith('.pdf') ? (
                    // eslint-disable-next-line jsx-a11y/alt-text
                    <Document file={item.other} onLoadError={console.error}>
                      <Page
                        renderMode="svg"
                        className={classes.pdfReader}
                        pageNumber={1}
                        scale={1}
                        onLoadError={error => console.error(error.message)}
                      />
                    </Document>
                  ) : (
                    <CardMedia component="img" image={item.other} />
                  )}
                </CardActionArea>
              </Card>
            </>
          ))}
          {others.length === 0 && <Typography>アップロードなし</Typography>}
        </div>
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            法人番号
          </Typography>
          {detail.companyCode && <Typography>{detail.companyCode}</Typography>}
          {!detail.companyCode && <Typography>なし</Typography>}
        </div>
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            【必須】代表者名
          </Typography>
          {detail.representativeName && (
            <Typography>{detail.representativeName}</Typography>
          )}
          {!detail.representativeName && <Typography>なし</Typography>}
        </div>
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            【必須】代表者名かな
          </Typography>
          {detail.representativeNameKana && (
            <Typography>{detail.representativeNameKana}</Typography>
          )}
          {!detail.representativeNameKana && <Typography>なし</Typography>}
        </div>
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            連絡欄
          </Typography>
          {detail.note && <Typography>{detail.note}</Typography>}
          {!detail.note && <Typography>なし</Typography>}
        </div>
        {!isConfirm ? (
          <React.Fragment>
            <Divider />
            <div className={classes.itemDiv}>
              <RadioGroup
                row
                value={approvalResult}
                onChange={e => {
                  setApprovalResult(e.target.value);
                  convertApprovalResultStr(e.target.value);
                }}
              >
                <FormControlLabel
                  value="CONFIRMED"
                  control={<Radio color="primary" />}
                  label="審査OK"
                />
                <FormControlLabel
                  value="RESERVED"
                  control={<Radio color="primary" />}
                  label="確認中（保留中）"
                />
                <FormControlLabel
                  value="REJECTION"
                  control={<Radio color="primary" />}
                  label="再提出依頼"
                />
                <FormControlLabel
                  value="NG"
                  control={<Radio color="primary" />}
                  label="審査NG"
                />
              </RadioGroup>
            </div>
            <div className={classes.itemDiv}>
              <TextField
                label="NG理由"
                multiline
                rows="4"
                value={ngReason}
                fullWidth
                className={classes.textFieldLong}
                margin="normal"
                onChange={e => {
                  setNgReason(e.target.value);
                }}
              />
            </div>
            <div className={classes.itemDiv}>
              <TextField
                label="事務局メモ"
                multiline
                value={adminMemo}
                rows="4"
                fullWidth
                className={classes.textFieldLong}
                margin="normal"
                onChange={e => {
                  setAdminMemo(e.target.value);
                }}
              />
            </div>
            <div className={classes.itemDiv}>
              <Typography variant="p" color="textPrimary">
                メールアドレス
              </Typography>
              <br />
              <Typography>{detail.email}</Typography>
              <br />
              <br />
              <Typography variant="p" color="textPrimary">
                電話番号
              </Typography>
              <br />
              <Typography>{detail.phone}</Typography>
            </div>
            <div className={classes.itemDiv}>
              <TextField
                label="口座名義"
                value={bankAccountHolder}
                rows="1"
                fullWidth
                className={classes.textFieldLong}
                margin="normal"
                onChange={e => {
                  setBankAccountHolder(e.target.value);
                }}
              />
            </div>
          </React.Fragment>
        ) : (
          <div className={classes.itemDiv}>
            <Typography variant="p" color="textPrimary">
              事務局メモ
            </Typography>
            {detail.adminMemo && <Typography>{detail.adminMemo}</Typography>}
            {!detail.adminMemo && <Typography>なし</Typography>}
          </div>
        )}
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openApprovalConfirmModal}>
          <GroupIdentityApprovalConfirm
            backAction={backAction}
            editAction={editAction}
            editConfirm={editConfirm}
            openApprovalProgress={openApprovalProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
